var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"services_single_page"}},[_c('services-navbar'),_c('services-details')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }